export { default as SideBySideCarousel } from './SideBySideCarousel';
